<template>
    <!-- Toasts: the answer to something just done in this window. What happens
         later or elsewhere goes to the bell (docs/notification-bell-proposal.md
         §4.10). One column at the bottom right, every toast as wide as it. -->
    <div class="toast-stack">
        <div v-for="n in notifications" :key="n.id" class="toast" @click="destroy(n.id)">
            <v-alert :color="n.color || 'info'" :icon="n.icon || ICONS[n.color] || ICONS.info" variant="tonal"
                density="compact" class="toast-alert">
                <div class="d-flex align-center ga-2">
                    <span class="flex-grow-1 toast-text">{{ n.text }}</span>
                    <v-btn v-if="n.action" variant="text" :color="n.color === 'accent' ? 'accent' : undefined"
                        class="toast-action" @click.stop="act(n)">
                        {{ n.action.text }}
                    </v-btn>
                </div>
            </v-alert>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.toast-stack {
    position: fixed;
    right: 16px;
    bottom: 16px;
    width: 360px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    pointer-events: none;
    // Above Vuetify's dialogs and menus (2000 and up), so an error raised
    // inside a dialog is readable and can be clicked away.
    z-index: 3000;
}

@media (max-width: 599.98px) {
    .toast-stack {
        left: 8px;
        right: 8px;
        bottom: 8px;
        width: auto;
    }
}

.toast {
    pointer-events: auto;
    cursor: pointer;
    border-radius: 4px;
    // `tonal` is a 12 % tint on a transparent background: the surface under
    // it keeps the page from showing through the text.
    background: rgb(var(--v-theme-surface));
    box-shadow: 0 3px 5px -1px rgba(0, 0, 0, .2), 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12);
}

.toast-text {
    overflow-wrap: anywhere;
}

.toast-action {
    flex: none;
    margin: -6px -8px -6px 0;
}
</style>

<script>
const ICONS = {
    success: "mdi-check-circle",
    info: "mdi-information",
    warning: "mdi-alert",
    error: "mdi-alert-circle",
    accent: "mdi-information",
};

let next_id = 0;

export default {
    name: "snackbar",
    data: () => ({
        notifications: [],
        ICONS,
    }),
    methods: {
        destroy(id) {
            this.notifications = this.notifications.filter((n) => n.id !== id);
        },
        act(n) {
            this.destroy(n.id);
            n.action.handler?.();
        },
        notificate(n) {
            const duplicate = this.notifications.some(
                (on) => on.text == n.text && on.color == n.color);
            if (duplicate) return;
            const id = ++next_id;
            this.notifications.push({ ...n, id });
            setTimeout(() => this.destroy(id), n.timeout ? n.timeout : 6000);
        },
    },
    mounted() {
        this._onNotification = (n) => this.notificate(n);
        this.$bus.on("notification", this._onNotification);
    },
    beforeUnmount() {
        this.$bus.off("notification", this._onNotification);
    },
};
// EMIT NOTIFICATIONS LIKE THIS (IN COMPONENTS OPTIONS API)
// this.$bus.emit('notification', {timeout: 5000, text:"Testing notifications!", color:"success"})

// AND LIKE THIS OUTSIDE COMPONENTS (IN COMPOSITION API)
// import bus from '/src/utils/event_bus'
// bus.emit('notification', {timeout: 5000, text:"Testing notifications!", color:"success"})

// With an action, drawn as a text button at the end:
// bus.emit('notification', {text: "3 new notifications", color: "accent",
//     icon: "mdi-bell-outline", action: {text: "Open", handler: () => ...}})
</script>
